/* eslint-disable react-hooks/rules-of-hooks */
import { CountryName } from "@lyfegen-platform/utils";
import * as Yup from "yup";
import { useAvailableTreatmentPacks } from "../hooks/useAvailableTreatmentPacks";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { Preparation } from "../models/generated/graphql";
import { GeneralFieldController } from "./general-field-controller";

export class TreatmentPackFieldController extends GeneralFieldController {
	override useControlProps(): FlexControlProps {
		const preparations = useAvailableTreatmentPacks(this.parent);

		return {
			controlType: "typeahead",
			getOptionLabel: (p: Preparation) =>
				p.regulates.some((treatment) => treatment.country?.name === CountryName.Switzerland)
					? `${p.BrandName} ${p.DescriptionDe || ""}`
					: p.BrandName,
			property: "id",
			options: preparations,
		};
	}

	override getValueTypeProps() {
		return {
			controlType: "typeahead",
			property: "DescriptionDe",
		};
	}

	protected override createFieldValidationRuleByDataType(): Yup.AnySchema {
		return Yup.object().nullable().required();
	}
}
